import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CustomerService } from '../../core/services/customer.service';

@Injectable({
    providedIn: 'root'
})
export class CustomerCountriesResolverService implements Resolve<string[]> {

    constructor(private customerService: CustomerService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<string[]> {
        return this.customerService.getCountries();
    }
}
